import { useState } from 'react';
import { Col, Container, Form, Row } from 'react-bootstrap';
import { FaEnvelope, FaMobileAlt } from 'react-icons/fa';
import '../../../assets/css/Drivers/DriverSetting/DriverNotification.css';
import DriverSettingsMasterLayout from '../../../layouts/Drivers/DriverSettingsMasterLayout';



const DriverNotification = () => {

  const [emailNotification, setEmailNotification] = useState(true);
  const [inAppNotification, setInAppNotification] = useState(true);

 
  const handleEmailToggle = () => {
    setEmailNotification(!emailNotification);
    console.log('Email Notification:', !emailNotification);
  };

  const handleInAppToggle = () => {
    setInAppNotification(!inAppNotification);
    console.log('In-App Notification:', !inAppNotification);
  };

  return (
    <DriverSettingsMasterLayout screenName={"App setting"} centered={true}>
      <div className="driver-notification-container">
      {/* Content Area */}
      <div className="driver-notification-content">
        <Container className="driver-notification-wrapper">
          {/* Email Notification Setting */}
          <Row className="mt-3">
            <Col>
              <div 
                className="driver-notification-item"
                onClick={handleEmailToggle}
              >
                <div className="driver-notification-left">
                  <div className="driver-notification-icon-wrapper">
                    <FaEnvelope className="driver-notification-icon" />
                  </div>
                  <div className="driver-notification-text">
                    <h6 className="driver-notification-label">Email Notification</h6>
                  </div>
                </div>
                <div className="driver-notification-right">
                  <Form.Check 
                    type="switch"
                    id="email-notification-switch"
                    checked={emailNotification}
                    onChange={handleEmailToggle}
                    onClick={(e) => e.stopPropagation()}
                    className="driver-notification-toggle"
                  />
                </div>
              </div>
            </Col>
          </Row>

          {/* In-App Notification Setting */}
          <Row className="mt-3">
            <Col>
              <div 
                className="driver-notification-item"
                onClick={handleInAppToggle}
              >
                <div className="driver-notification-left">
                  <div className="driver-notification-icon-wrapper">
                    <FaMobileAlt className="driver-notification-icon" />
                  </div>
                  <div className="driver-notification-text">
                    <h6 className="driver-notification-label">In-App Notification</h6>
                  </div>
                </div>
                <div className="driver-notification-right">
                  <Form.Check 
                    type="switch"
                    id="inapp-notification-switch"
                    checked={inAppNotification}
                    onChange={handleInAppToggle}
                    onClick={(e) => e.stopPropagation()}
                    className="driver-notification-toggle"
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
    </DriverSettingsMasterLayout>
    
  );
};

export default DriverNotification;